import * as React from "react";
import { useTranslation } from "react-i18next";

import Submit, { SubmitType } from "../../components/Submit/Submit";
import { PropsForm } from "../Info/Info";

export const CatchEmailForm: React.FC<PropsForm> = (props: PropsForm) => {
  const { t } = useTranslation("global");
  const infoSubmit: SubmitType = {
    textButtonSubmit: t("Las quiero"),
    textButtonSubmitting: t("Subiendo"),
    stateForm: props.stateForm,
    textInfo: props.infoRequest,
    color: props.color,
  };

  return (
    <form
      name="capture-email"
      method="post"
      // eslint-disable-next-line react/no-unknown-property
      netlify-honeypot="bot-field"
      data-netlify="true"
      onSubmit={(event) => {
        props.handleSubmit(event);
      }}
    >
      <input type="hidden" name="form-name" value="capture-email" />
      <div>
        <label hidden>Email </label>
        <input
          type="email"
          className={"a-input"}
          name="email"
          placeholder={t("Introduce tu Email")}
          required
        />
      </div>
      <div className={"m-submit"}>
        <div className={"m-policy"}>
          <label htmlFor="politica-email" style={{ color: "black" }}>
            {`${t("Acepto la")}`}{" "}
            <a
              href="/legal/politica-de-privacidad/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              {`${t("política de privacidad")}`}
            </a>{" "}
          </label>
          <input
            type="checkbox"
            name="politica-email"
            id="politica-email"
            value="acepta-politica"
            required
          />
        </div>
        <Submit submit={infoSubmit} />
      </div>
    </form>
  );
};
